module.exports = __webpack_public_path__ + "img/61.5f84fe5d.jpg";